import { useUser } from 'Shared/SiteProvider'
import { createMemo } from 'solid-js'
import { For } from 'solid-js'

const POSITIONS = ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w']

const CURSORS: Record<string, string> = {
	nw: 'nw-resize', n: 'n-resize', ne: 'ne-resize', e: 'e-resize',
	se: 'se-resize', s: 's-resize', sw: 'sw-resize', w: 'w-resize',
}

const SIZE = 8
const HALF = SIZE / 2

function handleCoords(p: string, w: number, h: number): { x: number; y: number } {
	const x = p.includes('e') ? w : p.includes('w') ? 0 : w / 2
	const y = p.includes('s') ? h : p.includes('n') ? 0 : h / 2
	return { x, y }
}

interface IDrawResizeHandles {
	impl;
	onHandleDown:  (handle: string, e: MouseEvent) => void
	positions?:    string[]
}

export function DrawResizeHandles(P: IDrawResizeHandles)
{
	const user = useUser();
	const box = createMemo(() => P.impl.effectiveBox(!user));

	const width = () => P.impl.getBBox(!useUser()).dims.width;
	const height = () => box().dims.height;

	return (
		<For each={P.positions ?? POSITIONS}>
			{p => (
				<rect
					data-p={p}
					x={handleCoords(p, width(), height()).x - HALF}
					y={handleCoords(p, width(), height()).y - HALF}
					width={SIZE}
					height={SIZE}
					rx="1"
					fill="#fff"
					stroke="#4d9eff"
					stroke-width="2"
					style={{ cursor: CURSORS[p] }}
					onMouseDown={e => P.onHandleDown(p, e)}
				/>
			)}
		</For>
	);
}
